module.exports = __webpack_public_path__ + "static/media/kennzeichnung.bb6a2e96.jpg";